import { Button, Collapse, Stack, Text } from "@mantine/core";
import {
  IconChevronCompactDown,
  IconChevronCompactUp,
} from "@tabler/icons-react";
import { ReactNode, useState } from "react";

interface Props {
  filterName: string;
  children: ReactNode;
}

const FilterLayout = ({ filterName, children }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <Stack align="flex-start" w="100%" gap="0">
      <Button
        variant="transparent"
        leftSection={
          isCollapsed ? <IconChevronCompactUp /> : <IconChevronCompactDown />
        }
        onClick={() => setIsCollapsed(!isCollapsed)}
        p="0 0 0 0"
      >
        <Text fw={700}>{filterName}</Text>
      </Button>
      <Collapse expanded={!isCollapsed} w="100%">
        {children}
      </Collapse>
    </Stack>
  );
};

export default FilterLayout;
